import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const CONVERTER_COMMON_LANG: {
  // TITLE
  STUDY_TITLE: MvnCodeFE;
  IMPORT_TITLE: MvnCodeFE;
  SOURCE_DATA_TITLE: MvnCodeFE;
  SETTINGS_TITLE: MvnCodeFE;
  SETTINGS_DATASET_VARIABLE_TITLE: MvnCodeFE;
  SETTINGS_CONVERSION_FACTORS_TITLE: MvnCodeFE;
  SETTINGS_MY_DICTIONARY_TITLE: MvnCodeFE;
  DEFINE_XML_TITLE: MvnCodeFE;
  DATA_FLOW_TITLE: MvnCodeFE;
  CRF_LABELING_TITLE: MvnCodeFE;
  VALIDATION_TITLE: MvnCodeFE;
  AUDIT_TRAIL_TITLE: MvnCodeFE;
  MEMBERS_TITLE: MvnCodeFE;

  // DESCRIPTION
  STUDY_TITLE_DESCRIPTION: MvnCodeFE;
  IMPORT_TITLE_DESCRIPTION: MvnCodeFE;
  VALIDATION_TITLE_DESCRIPTION: MvnCodeFE;
  AUDIT_TRAIL_TITLE_DESCRIPTION: MvnCodeFE;
  TABLE_ROW_SELECT_DESCRIPTION: MvnCodeFE;
  EMPTY_DATA_DESCRIPTION: MvnCodeFE;
  EMPTY_ORGANIZATION_DESCRIPTION: MvnCodeFE;

  // VERB
  RESET_VERB: MvnCodeFE;
  ADD_VERB: MvnCodeFE;
  CREATE_VERB: MvnCodeFE;
  SAVE_VERB: MvnCodeFE;
  DELETE_VERB: MvnCodeFE;
  CONFIRM_VERB: MvnCodeFE;
  APPLY_VERB: MvnCodeFE;
  CANCEL_VERB: MvnCodeFE;
  UPDATE_VERB: MvnCodeFE;
  EDIT_VERB: MvnCodeFE;
  EXPORT_VERB: MvnCodeFE;
  FILE_UPLOAD_VERB: MvnCodeFE;
  SEARCH_VERB: MvnCodeFE;
  OK_VERB: MvnCodeFE;
  CLOSE_VERB: MvnCodeFE;
  RENAME_VERB: MvnCodeFE;
  ADD_ROW_VERB: MvnCodeFE;
  COPY_VERB: MvnCodeFE;
  IMPORT_VERB: MvnCodeFE;
  FILTER_VERB: MvnCodeFE;
  FILTERED_VERB: MvnCodeFE;
  KEY_VERB: MvnCodeFE;
  REMOVE_VERB: MvnCodeFE;
  LIBRARY_VERB: MvnCodeFE;
  LOAD_VERB: MvnCodeFE;

  FORM_REQUIRED: MvnCodeFE;
  FORM_NUMBER: MvnCodeFE;
  CREATE_ORGANIZATION: MvnCodeFE;

  NO_GRANT_PRIVILEGES: MvnCodeFE;
  FORBIDDEN_PAGE_ACCESS: MvnCodeFE;
} = {
  // NOUN
  STUDY_TITLE: {
    ko: "Study",
    en: "Study",
  },
  IMPORT_TITLE: {
    ko: "Import",
    en: "Import",
  },
  SOURCE_DATA_TITLE: {
    ko: "Source Data",
    en: "Source Data",
  },
  SETTINGS_TITLE: {
    ko: "Settings",
    en: "Settings",
  },
  SETTINGS_DATASET_VARIABLE_TITLE: {
    ko: "Dataset & Variables",
    en: "Dataset & Variables",
  },
  SETTINGS_CONVERSION_FACTORS_TITLE: {
    ko: "Conversion Factors",
    en: "Conversion Factors",
  },
  SETTINGS_MY_DICTIONARY_TITLE: {
    ko: "My Dictionary",
    en: "My Dictionary",
  },
  DEFINE_XML_TITLE: {
    ko: "Define-XML",
    en: "Define-XML",
  },
  DATA_FLOW_TITLE: {
    ko: "Data Flow",
    en: "Data Flow",
  },
  CRF_LABELING_TITLE: {
    ko: "CRF Labeling",
    en: "CRF Labeling",
  },
  VALIDATION_TITLE: {
    ko: "Validation",
    en: "Validation",
  },
  AUDIT_TRAIL_TITLE: {
    ko: "Audit Trail",
    en: "Audit Trail",
  },
  MEMBERS_TITLE: {
    ko: "Members",
    en: "Members",
  },
  STUDY_TITLE_DESCRIPTION: {
    ko: "스터디를 생성하고 원하는 스터디로 진입할 수 있습니다.",
    en: "Create a folder for your study and upload data.",
  },
  IMPORT_TITLE_DESCRIPTION: {
    ko: "Data file을 업로드 할 수 있습니다.",
    en: "Data files can be uploaded.",
  },
  VALIDATION_TITLE_DESCRIPTION: {
    ko: "CDISC CORE 엔진을 이용하여 데이터 세트과 Define-xml의 유효성을 평가합니다.",
    en: "Validating Dataset and Define-XML using the CDISC CORE Engine.",
  },
  AUDIT_TRAIL_TITLE_DESCRIPTION: {
    ko: "스터디 내에 사용자의 활동을 확인할 수 있습니다.",
    en: "You can check your activity within the study.",
  },
  TABLE_ROW_SELECT_DESCRIPTION: {
    ko: "{count}개 선택됨",
    en: "{count} items are selected",
  },
  EMPTY_DATA_DESCRIPTION: {
    ko: "데이터가 없습니다.",
    en: "There is no data.",
  },
  EMPTY_ORGANIZATION_DESCRIPTION: {
    ko: "생성된 Organization이 없거나\n소속된 Organization이 없습니다.",
    en: "No organization has been created,\nor you are not a member of any organization.",
  },

  // VERB
  RESET_VERB: {
    ko: "초기화",
    en: "Reset",
  },
  ADD_VERB: {
    ko: "추가",
    en: "Add",
  },
  CREATE_VERB: {
    ko: "생성",
    en: "Create",
  },
  SAVE_VERB: {
    ko: "저장",
    en: "Save",
  },
  DELETE_VERB: {
    ko: "삭제",
    en: "Delete",
  },
  CONFIRM_VERB: {
    ko: "적용",
    en: "Confirm",
  },
  APPLY_VERB: {
    ko: "적용",
    en: "Apply",
  },
  CANCEL_VERB: {
    ko: "취소",
    en: "Cancel",
  },
  UPDATE_VERB: {
    ko: "수정",
    en: "Update",
  },
  EDIT_VERB: {
    ko: "수정",
    en: "Edit",
  },
  EXPORT_VERB: {
    ko: "내보내기",
    en: "Export",
  },
  FILE_UPLOAD_VERB: {
    ko: "파일 업로드",
    en: "File Upload",
  },
  SEARCH_VERB: {
    ko: "검색",
    en: "Search",
  },
  OK_VERB: {
    ko: "확인",
    en: "OK",
  },
  CLOSE_VERB: {
    ko: "닫기",
    en: "Close",
  },
  RENAME_VERB: {
    ko: "이름 변경",
    en: "Rename",
  },
  ADD_ROW_VERB: {
    ko: "행 추가",
    en: "Add Row",
  },
  FILTER_VERB: {
    ko: "필터",
    en: "Filter",
  },
  FILTERED_VERB: {
    ko: "필터 적용됨 ({value})",
    en: "Filtered ({value})",
  },
  COPY_VERB: {
    ko: "복사",
    en: "Copy",
  },
  IMPORT_VERB: {
    ko: "가져오기",
    en: "Import",
  },
  KEY_VERB: {
    ko: "키",
    en: "Key",
  },
  REMOVE_VERB: {
    ko: "삭제",
    en: "Remove",
  },
  LIBRARY_VERB: {
    ko: "라이브러리",
    en: "Library",
  },
  LOAD_VERB: {
    ko: "불러오기",
    en: "Load",
  },

  FORM_REQUIRED: {
    ko: "필수 입력값입니다.",
    en: "This field is required.",
  },
  FORM_NUMBER: {
    ko: "숫자를 입력해주세요.",
    en: "Please enter a number.",
  },
  CREATE_ORGANIZATION: {
    ko: "Organization 생성하기",
    en: "Create Organization",
  },
  NO_GRANT_PRIVILEGES: {
    ko: "{privilege} 권한이 없습니다.",
    en: "You do not have permission to access {privilege}.",
  },
  FORBIDDEN_PAGE_ACCESS: {
    ko: "페이지 접근 권한이 없습니다.",
    en: "You do not have the privilege to access this page.",
  },
};

MvnCodeInitiate(CONVERTER_COMMON_LANG);
